import { jwtDecode } from "jwt-decode";

import { updateGlobalConfigurationsAction } from "store/modules/globalConfiguration/actions";
import { createAppAsyncThunk } from "store/rootReducer";

import api from "services/api";
import { globalConfigurationsUtils } from "services/utils/globalConfigurations";

import { signInSuccess, signinFailure, logout as logoutAction } from "./index";

type SignInCredentials =
  | { email: string; password: string; mfaCode?: string }
  | { entraToken: string };

export const signInThunk = createAppAsyncThunk(
  "auth/signIn",
  async (credentials: SignInCredentials, { dispatch, rejectWithValue }) => {
    try {
      const body: any = { platform: 0 };

      if ("entraToken" in credentials) {
        body.entraToken = credentials.entraToken;
      } else {
        body.email = credentials.email;
        body.password = credentials.password;
        if (credentials.mfaCode) {
          body.mfaCode = Number(credentials.mfaCode);
        }
      }

      const { data } = await api.post(
        "/v1/UserCustomerAuthentication/CheckCredentials",
        body,
      );

      if (!data.data) {
        dispatch(signinFailure(data.message));
        return rejectWithValue({ message: data.message, requiresMfa: false });
      }

      const { access_Token, refresh_Token } = data.data.tokenResponse;
      const user = {
        ...data.data.userCustomer,
        hash: data.data.userCustomerAccess?.hash,
      };
      const systemConfiguration = Array.isArray(data.data.systemConfiguration)
        ? data.data.systemConfiguration
        : [];

      const decodedToken = jwtDecode<{ exp: number }>(access_Token);
      const expireIn = new Date((decodedToken.exp - 300) * 1000).toISOString();

      dispatch(
        signInSuccess({
          user,
          accessToken: access_Token,
          refreshToken: refresh_Token,
          expireIn,
        }),
      );
      dispatch(updateGlobalConfigurationsAction(systemConfiguration));
      globalConfigurationsUtils.setLocalstorage(systemConfiguration);

      return {
        user,
        accessToken: access_Token,
        refreshToken: refresh_Token,
        systemConfiguration,
      };
    } catch (err: any) {
      const statusCode = err.response?.status;
      const msg = err.response?.data?.message || err.message || "Erro ao logar";
      const requiresMfa = statusCode && statusCode === 423;

      dispatch(signinFailure(msg));
      return rejectWithValue({ message: msg, requiresMfa });
    }
  },
);

export const logoutThunk = createAppAsyncThunk(
  "auth/logout",
  async (_, { dispatch, getState }) => {
    try {
      const { user } = getState().user;
      const { accessToken } = getState().auth;

      await api.delete("/v1/UserCustomerAccess/DeleteUserCustomerAccess", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        params: {
          hash: user.hash,
        },
      });
    } catch {
      // ignore
    } finally {
      dispatch(logoutAction());
    }
  },
);
